import { Component, ComponentFactoryResolver, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonApiErrorHandlerService } from '../../../shared/services/common-api-error-handler.service';
import { MatDialog } from '@angular/material';
import { MetricsService } from '../../../shared/services/metrics.service';
import { MetricsDataModel } from '../../../shared/components/models/metrics/metrics-data.model';
import { CustomMetricsName } from '../../../shared/components/models/metrics/custom-metrics-name.enum';
import { MetricsType } from '../../../shared/components/models/metrics/metrics-type.enum';
import {ComponentsFactoryService} from '../../../shared/services/components-factory.service';
import {COMPONENTS_FACTORY_MAPPING} from '../../configs/components-factory-mapping';
import {NotificationComponentKey} from '../../enums/components-keys';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  @ViewChild('dynamicNotificationContainer', {read: ViewContainerRef}) dynamicNotificationContainer: ViewContainerRef;
  activeViewComponent: string;
  private applicationMetric: MetricsDataModel;

  constructor(private commonApiErrorHandlerService: CommonApiErrorHandlerService,
              private dialog: MatDialog,
              private metricsService: MetricsService,
              private componentsFactoryService: ComponentsFactoryService,
              @Inject(ComponentFactoryResolver) private factoryResolver: ComponentFactoryResolver) {
    this.setUpGlobalErrorsMetrics();
  }

  ngOnInit() {
    this.componentsFactoryService.init(COMPONENTS_FACTORY_MAPPING);
    this.initMetric();
    this.commonApiErrorHandlerService.onError.subscribe(errorResponse => {
      switch (errorResponse.status) {
        case 0:
          this.activeViewComponent = NotificationComponentKey.CONNECTION_ERROR;
          break;
        case 500:
          this.activeViewComponent = NotificationComponentKey.ERROR;
          break;
        default:
          break;
      }

      this.createActiveViewComponent();
    });

    this.commonApiErrorHandlerService.onCustomError.subscribe(componentName => {
      this.activeViewComponent = componentName;
      this.createActiveViewComponent();
    });
  }

  private createActiveViewComponent() {
    if (this.dynamicNotificationContainer && this.activeViewComponent) {
      this.dialog.closeAll();
      if (this.dynamicNotificationContainer.length > 0) {
        this.dynamicNotificationContainer.clear();
      }
      const factory = this.factoryResolver.resolveComponentFactory(this.componentsFactoryService.getComponent(this.activeViewComponent));
      this.dynamicNotificationContainer.createComponent(factory);
    }
  }

  private initMetric(): void {
    this.applicationMetric = new MetricsDataModel(CustomMetricsName.APPLICATION, MetricsType.COMPONENT);
    this.applicationMetric.open();
    this.onExitApp();
  }

  private onExitApp() {
    let context = this;
    window.onbeforeunload = function (event) {
      context.applicationMetric.close();
      context.metricsService.send(context.applicationMetric);
    };
  }

  private setUpGlobalErrorsMetrics(): void {
    window.addEventListener('unhandledrejection', (event) => {
      const unhandledRejectionMetricsBody = {
        reason: event.reason,
        stack: event.reason ? event.reason.stack : null
      };

      this.metricsService.sendSimpleMetric(CustomMetricsName.UNHANDLED_REJECTION, MetricsType.ERROR, JSON.stringify(unhandledRejectionMetricsBody));
    });
  }

}
